<template>
  <main id="studySearchApp" role="main">
    <router-view></router-view>
    <generic-error-message></generic-error-message>
  </main>
</template>

<script>
export default {
    name: 'studySearchApp'
}
</script>

<style lang="scss">
  @import './styles/global';
</style>


// WEBPACK FOOTER //
// src/app_studySearch.vue